import clsx from 'clsx';
import { Link } from 'react-router-dom';

export interface BrandProps {
    /** Text size class, e.g. `text-ticket`. The mark is 24 px (min 16 px, docs/brand/README.md). */
    className?: string;
    /** Mark only. */
    markOnly?: boolean;
}

/** Mark from /favicon.svg (orange ring, teal block: readable on light and coal) beside "QckOrder". Clear space = gap. */
export const Brand = ({ className, markOnly = false }: BrandProps) => (
    <span className={clsx('inline-flex items-center gap-2 font-display', className)}>
        <img src="/favicon.svg" alt="" width={24} height={24} className="size-6 shrink-0" />
        {!markOnly && <span>QckOrder</span>}
    </span>
);

/** Brand linking Home. `rail` shows the mark only. */
export const Wordmark = ({ rail = false }: { rail?: boolean }) => (
    <Link to="/" aria-label="QckOrder" className="inline-flex h-11 items-center rounded-control px-2 text-strong">
        <Brand markOnly={rail} className="text-ticket" />
    </Link>
);
